<template>
  <div :class="active ? 'card active' : 'card'">
    <div class="header">
      <h3>{{title}}</h3>
      <a-tooltip :arrowPointAtCenter="true">
        <template slot="title">
          {{tip}}
        </template>
        <a-icon type="question-circle" />
      </a-tooltip>
    </div>
    <div class="data-item">
      <label>今日</label>
      <span v-line-clamp="1" :title="todayVal">
        {{todayVal}}
      </span>
    </div>
    <div class="data-item">
      <label>昨日全天</label>
      <span v-line-clamp="1" :title="yesterdayVal">
        {{yesterdayVal}}
      </span>
    </div>
  </div>
</template>
<script>
import { Icon, Tooltip } from 'ant-design-vue'
export default {
  name: 'salesdata-card',
  props: {
    title: {
      type: String
    },
    tip: {
      type: String
    },
    todayVal: {
      type: String
    },
    yesterdayVal: {
      type: String
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  components: {
    [Icon.name]: Icon,
    [Tooltip.name]: Tooltip
  }
}
</script>

<style lang="scss" scoped>
  .card {
    border: 1px solid #e2e2e2;
    background: #ffffff;
    padding: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
    &.active {
      border: 1px solid #1c7ae5;
      background: #f4f9ff;
    }
    .header {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      h3 {
        margin-right: 8px;
        font-size: 14px;
        color: #333333;
        font-weight: 400;
        line-height: 20px;
      }
    }
    .data-item {
      display: flex;
      align-items: center;
      line-height: 20px;
      margin-bottom: 12px;
      &:last-child{
        margin-bottom: 0;
      }
      label {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        margin-right: 12px;
        flex-shrink: 0;
      }
      span {
        font-size: 20px;
        font-weight: 500;
        color: #1c7ae5;
        cursor: pointer;
      }
    }
  }
</style>